<template>
    <div class="modal-add-credit">
        <div class="main-modal">
            <div class="close" @click="$parent.close()">
                <b-icon icon="close"></b-icon>
            </div>
            <div class="section">
                <h4 class="title">{{ $t("Add credit") }}</h4>
                <div class="accounts">
                    <p>
                        {{
                            $t(
                                "You can now add credit to your ALKOON wallet by bank transfer through our bank accounts as below:"
                            )
                        }}
                    </p>
                    <div
                        style="margin-top: 10px; display: flex; flex-wrap: wrap"
                    >
                        <div style="width: 50%; padding: 5px">
                            <img
                                style="
                                    width: 120px;
                                    position: relative;
                                    height: 50px;
                                "
                                src="@/assets/images/ahly-bank.webp"
                            />
                            <div>
                                <p>
                                    <span>{{ $t("Account name") }}:</span>
                                    <span style="color: #4952ff; margin: 0 10px"
                                        >حسن علي محمد السعد</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("Account number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="color: #4952ff; margin: 0 10px"
                                        >05 2776 8100 0104</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("IBAN number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="color: #4952ff; margin: 0 10px"
                                        >SA 29 1000 0005 2776 8100 0104</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div style="width: 50%; padding: 5px">
                            <img
                                style="
                                    width: 170px;
                                    position: relative;
                                    height: 50px;
                                "
                                src="@/assets/images/raghi.png"
                            />
                            <div>
                                <p>
                                    <span>{{ $t("Account name") }}:</span>
                                    <span style="color: #4952ff; margin: 0 10px"
                                        >متوقف حاليا</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("Account number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="color: #4952ff; margin: 0 10px"
                                        >متوقف حاليا</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("IBAN number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="color: #4952ff; margin: 0 10px"
                                        >متوقف حاليا</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div style="width: 50%; padding: 5px">
                            <img
                                style="
                                    width: 130px;
                                    position: relative;
                                    height: 50px;
                                "
                                src="@/assets/images/enmaa.png"
                            />
                            <div>
                                <p>
                                    <span>{{ $t("Account name") }}:</span>
                                    <span style="color: #4952ff; margin: 0 10px"
                                        >مؤسسة موقع الأصلي للتجارة</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("Account number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="
                                            color: #4952ff;
                                            margin: 0 10px;
                                            letter-spacing: 2px;
                                        "
                                        >68 2031 5581 2000</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("IBAN number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="
                                            color: #4952ff;
                                            margin: 0 10px;
                                            letter-spacing: 2px;
                                        "
                                        >SA 15 0500 0068 2031 5581 2000</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div style="width: 50%; padding: 5px">
                            <img
                                style="
                                    width: 130px;
                                    position: relative;
                                    height: 50px;
                                "
                                src="@/assets/images/stc-pay.png"
                            />
                            <div>
                                <p>
                                    <span>{{
                                        $t(
                                            "Transfer with STC-PAY and accept Mada, Visa and mastercard"
                                        )
                                    }}</span>
                                </p>
                                <p>
                                    <span>{{ $t("Account name") }}:</span>
                                    <span style="color: #4952ff; margin: 0 10px"
                                        >HASSAN ALSAAD</span
                                    >
                                </p>
                                <p>
                                    <span>{{ $t("Account number") }}:</span>
                                    <span
                                        dir="ltr"
                                        style="
                                            color: #4952ff;
                                            margin: 0 10px;
                                            letter-spacing: 2px;
                                        "
                                        >05 6458 7039</span
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <form @submit.prevent>
                    <div class="custom-input">
                        <div class="input-container">
                            <p>
                                {{ $t("Transaction date") }}
                            </p>
                            <date-picker
                                :placeholder="$t('Transaction date')"
                                id="datepicker"
                                value-type="format"
                                type="date"
                                ref="date"
                                :disabled-date="(date) => date >= new Date()"
                                v-model="form.transaction_date"
                                format="YYYY-MM-DD"
                            ></date-picker>
                        </div>
                        <p
                            class="is-error"
                            v-if="validation.includes('transaction_date')"
                        >
                            {{ $t("Required") }}
                        </p>
                    </div>
                    <div class="custom-input">
                        <div class="input-container">
                            <p>
                                {{ $t("Bank account") }}
                            </p>
                            <b-field>
                                <b-select
                                    v-model="form.bank_id"
                                    :placeholder="
                                        $t('Please choose the bank account')
                                    "
                                    expanded
                                >
                                    <option
                                        :value="bank.id"
                                        v-for="(bank, i) in banks"
                                        :key="i"
                                    >
                                        {{ bank.bank_name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <p
                            class="is-error"
                            v-if="validation.includes('bank_id')"
                        >
                            {{ $t("Required") }}
                        </p>
                    </div>
                    <div class="custom-input">
                        <div class="input-container">
                            <p>
                                {{ $t("Amount") }}
                            </p>
                            <money v-model="form.amount" v-bind="money" />
                        </div>
                        <p
                            class="is-error"
                            v-if="validation.includes('amount')"
                        >
                            {{ $t("Required") }}
                        </p>
                    </div>
                    <div class="custom-input">
                        <div class="input-container">
                            <p>
                                {{ $t("Transaction file") }}
                            </p>
                            <input
                                :placeholder="$t('File')"
                                @change="saveFile($event)"
                                type="file"
                                :required="true"
                            />
                        </div>
                        <p
                            class="is-error"
                            v-if="validation.includes('transaction_file')"
                        >
                            {{ $t("Required") }}
                        </p>
                        <p class="error" v-if="error && error.transaction_file">
                            {{ $t(error.transaction_file[0]) }}
                        </p>
                    </div>

                    <div class="btn">
                        <Loading v-if="loading" />
                        <button v-if="!loading" @click="submit" class="button">
                            <span>{{ $t("Send") }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Compressor from "compressorjs";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Loading from "@/components/Loading";
import { Money } from "v-money";
export default {
    components: {
        DatePicker,
        Loading,
        Money,
    },
    data() {
        return {
            loading: false,
            error: null,
            form: {
                transaction_date: null,
                bank_id: null,
                amount: null,
                transaction_file: null,
            },
            money: {
                decimal: ".",
                thousands: ",",
                suffix: " " + this.$t("SAR"),
                precision: 2,
                masked: false,
            },
            validation: [],
        };
    },
    computed: {
        banks() {
            return this.$store.state.banks;
        },
    },
    methods: {
        saveFile(e) {
            let that = this;
            this.form.transaction_file = e.target.files[0];

            if (
                e.target.files[0].size > 50000 &&
                e.target.files[0].type.includes("image")
            ) {
                let quality = 50000 / e.target.files[0].size;

                new Compressor(e.target.files[0], {
                    quality,
                    success(result) {
                        that.form.transaction_file = result;
                    },
                });
            }
        },
        submit() {
            this.validation = [];
            this.loading = true;
            for (let key in this.form) {
                if (!this.form[key]) this.validation.push(key);
            }

            if (this.validation.length) {
                this.$buefy.toast.open({
                    message: this.$t("Please add a valid info"),
                    type: "is-primary",
                });
                this.loading = false;
                return;
            }

            let formData = new FormData();
            for (let key in this.form) {
                formData.append(key, this.form[key]);
            }

            this.$store
                .dispatch("CREDIT_REQUEST", formData)
                .then((res) => {
                    this.loading = false;
                    this.$parent.close();
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.mx-datepicker {
    width: 100% !important;
}

.error {
    color: tomato;
}

.accounts {
    background: #fafafa;
    padding: 15px;
    border-radius: 5px;
    text-align: left;

    &:lang(ar) {
        text-align: right;
    }
}

.modal-add-credit {
    text-align: center;
    overflow: hidden;

    img {
        position: absolute;
        top: 3px;
        right: 0;

        &:lang(ar) {
            right: auto !important;
            left: 0;
        }
    }

    .main-modal {
        position: relative;
        display: inline-block;
        background-color: white;
        width: 945px;
        min-height: 600px;
        border-radius: 15px;
    }

    .close {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }

    .body {
        margin-top: 80px;
        text-align: left;

        &:lang(ar) {
            text-align: right !important;
        }

        p {
            font-size: 20px;
            color: #777;
        }
    }

    form {
        margin-top: 40px;
        text-align: left;

        &:lang(ar) {
            text-align: right !important;
        }

        .btn {
            height: 100%;
            text-align: left;
            margin-top: 1em;

            button {
                background: #4952ff;
                color: white;
                border: none;
                width: 35%;
            }
        }
    }

    .is-error {
        padding: 25px 10px 0;
    }

    .custom-input {
        position: relative;
        display: flex;
        align-items: center;
        // border-bottom: 2px solid #9b9b9b;
        margin-bottom: 20px;
        width: 100%;

        .input-container {
            // display: flex;
            width: 55%;
        }

        &.active {
            border-color: #4bcaae;
        }

        input {
            width: 100%;
            border-radius: 10px;
            color: #444444;
            font-size: 1em;
            font-weight: 100 !important;
            -webkit-transition: 0.25s ease-out;
            transition: 0.25s ease-out;
            display: inline-block;
            border: 0 !important;
            background: #f2f2f2;
            padding: 13px;
        }
    }
}
</style>
